module.exports = __webpack_public_path__ + "img/shopping-basket.628f1ff5.svg";